// extracted by mini-css-extract-plugin
module.exports = {"time-label":"_3ea6fa5da8--time-label--VOf99","relative":"_3ea6fa5da8--relative--TqzUc","absolute":"_3ea6fa5da8--absolute--D9jpj"};